export { default } from './ProductPageHeader';
